var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoE9LightNoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_18586_4792)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0701 15.1919C22.5172 15.1919 22.9773 15.0869 23.4507 14.8769C23.9305 14.6669 24.2034 14.4901 24.2691 14.3464C24.2954 14.2911 24.3184 14.0867 24.3381 13.733C24.3578 13.3738 24.3677 13.0837 24.3677 12.8626C24.3677 11.7132 24.1376 10.7792 23.6775 10.0608C23.2173 9.34243 22.5435 8.98323 21.656 8.98323C21.0118 8.98323 20.4891 9.22915 20.0881 9.72098C19.6937 10.2128 19.4965 10.9478 19.4965 11.9259C19.4965 12.7328 19.6806 13.4788 20.0487 14.164C20.4234 14.8493 21.0972 15.1919 22.0701 15.1919ZM21.794 8.51074C23.2403 8.51074 24.3578 8.99705 25.1467 9.96966C25.9356 10.9367 26.33 12.0171 26.33 13.2108C26.33 14.0507 26.1426 14.9045 25.7679 15.7722C25.3932 16.6398 24.8476 17.4134 24.131 18.0932C23.2962 18.8779 22.2378 19.4609 20.9559 19.8422C20.2393 20.0577 19.3354 20.2235 18.2442 20.3396L18.1456 20.008C18.8292 19.8754 19.3979 19.7344 19.8515 19.5852C20.6666 19.3144 21.3207 18.9829 21.8138 18.5905C22.5106 18.0324 23.0661 17.4107 23.4802 16.7254C23.901 16.0347 24.1639 15.4572 24.2691 14.993L23.924 15.2085C23.4375 15.518 22.8656 15.7307 22.2082 15.8468C21.8664 15.9131 21.5541 15.9462 21.2714 15.9462C20.1539 15.9462 19.2664 15.6147 18.609 14.9515C17.9582 14.2828 17.6328 13.4871 17.6328 12.5642C17.6328 11.3871 18.0207 10.4173 18.7964 9.65466C19.5787 8.89205 20.5779 8.51074 21.794 8.51074Z",
    fill: "#0E5133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67578 23.1263C6.39203 23.0478 6.85474 22.9169 7.06391 22.7337C7.27942 22.5439 7.38717 22.0695 7.38717 21.3105V10.6897C7.38717 9.97647 7.28259 9.51189 7.07342 9.29595C6.86425 9.07348 6.39837 8.93606 5.67578 8.88372V8.51074H16.0202L16.0868 11.3964H15.5924C15.4276 10.5065 15.1804 9.93066 14.8507 9.66893C14.5211 9.40719 13.7859 9.27632 12.645 9.27632H10.0018C9.71657 9.27632 9.53909 9.3254 9.46937 9.42355C9.40598 9.51516 9.37429 9.69183 9.37429 9.95357V15.7453H12.3692C13.1996 15.7453 13.7288 15.6177 13.957 15.3625C14.1852 15.1073 14.369 14.5904 14.5085 13.8117H14.9648V18.4641H14.5085C14.3627 17.6855 14.1757 17.1718 13.9475 16.9231C13.7193 16.668 13.1932 16.5404 12.3692 16.5404H9.37429V21.8896C9.37429 22.2887 9.49472 22.5243 9.73559 22.5963C9.98279 22.6683 10.7149 22.7043 11.9319 22.7043C13.2503 22.7043 14.2232 22.557 14.8507 22.2626C15.4783 21.9616 16.0424 21.2385 16.5431 20.0934H17.0851L16.2008 23.4895H5.67578V23.1263Z",
    fill: "#0E5133"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_18586_4792",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18586_4792"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoE9LightNoText);
export default __webpack_public_path__ + "static/media/logo-e9-light-no-text.e662b20970749403c402fb1b2f4a6649.svg";
export { ForwardRef as ReactComponent };